import React from 'react'
import styled from 'styled-components'

export default ({img, left, zIndex}) => {
  return (
    <Container img={img} left={left} zIndex={zIndex}>
      
    </Container>
  )
}

const Container = styled.div`
  position: absolute;
  clip-path: polygon(25% 0%, 100% 0, 75% 100%, 0% 100%);
  background-image: url('${props => props.img}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 15rem;
  height: 15rem;
  left: ${props => props.left}rem;
  z-index: ${props => props.zIndex};
  @media(min-width: 900px) {
    width: 25rem;
    height: 20rem;
    left: ${props => props.left * 1.7}rem;
  }
  @media(min-width: 1100px) {
    width: 30rem;
    height: 25rem;
    left: ${props => props.left * 2}rem;
  }
  @media(min-width: 1300px) {
    width: 36rem;
    height: 31rem;
    left: ${props => props.left * 2.5}rem;
  }
`